import { z } from 'zod';
import { paginationFiltersSchema, sortFiltersSchema } from 'utils/schemas';
import { companyStatuses } from './companies.types';

export const companiesFiltersSchema = z
  .object({
    companies: z.array(z.string()).catch([]),
    status: z.array(z.enum(companyStatuses)).catch([]),
    search: z.string().catch(''),
  })
  .merge(sortFiltersSchema)
  .merge(paginationFiltersSchema);

export const parentCompaniesFiltersSchema = z
  .object({})
  .merge(paginationFiltersSchema);
